import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.CotizadorPaquete;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Alto: validation.required,
        Ancho: validation.required,
        Largo: validation.required,
        Cantidad: validation.required,
        Peso: validation.required,
    };

    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un CotizadorPaquete
*/
export class CotizadorPaqueteEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, value => validar(value));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar paquete"
            >
                <h3>Cantidad de paquetes iguales</h3>
                {kea.autogrid(6, [
                    <Number field="Cantidad" />,
                ])}

                <h3>Peso y dimensiones</h3>
                {kea.autogrid(6, [
                    <Number field="Peso" label="Peso (kg)" />,
                    <Number field="Largo" label="Largo (cm)" />,
                    <Number field="Ancho" label="Ancho (cm)" />,
                    <Number field="Alto" label="Alto (cm)" />,
                ])}

                <h3>Seguro opcional</h3>
                {kea.autogrid(6, [
                    <Number field="ValorDeclarado" label="Valor declarado ($)" format="currency" />,
                    <Number field="ValorFactura" label="Valor factura ($)" format="currency" />,
                ])}
            </kea.Modal>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/paquetes/edit.tsx